import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import { memoryCrudStateConfig } from "../consts";

export const {
  fetchAllActionFactory: fetchAllMemoriesActionFactory,
  createActionFactory: createMemoryActionFactory
} = makeCrudStateActionFactories(memoryCrudStateConfig);
